import {GuideStateApi} from "@khan/guide-state";
import type {ImageInput} from "@khan/guide-types";

/**
 * Update the images in the guide state.
 */
export function updateImageGuideStateForAttach(images: Array<ImageInput>) {
    if (images.length) {
        GuideStateApi.set("images", [
            ...GuideStateApi.latest().images,
            ...images.map((image) => ({
                ...image,
                // Attached images do not have interactionIDs, and they haven't
                // yet been sent to the moderation check.
                interactionID: undefined,
                moderated: false,
            })),
        ]);
    }
}
